<template>
  <v-dialog v-model="dialog" width="400">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Upload Comprovante de Pagamento
      </v-card-title>
      <v-layout align-center justify-center wrap fill-height>
        <v-flex xs12>
          <v-text-field
            label="Comprovante"
            @click="onPickFileComprov"
            v-model="fileNameComprov"
            prepend-icon="attach_file"
          ></v-text-field>

          <input
            style="display: none"
            @change="detectFiles($event, 'comprov')"
            accept="application/pdf,image/*"
            type="file"
            ref="comprovFile"
          />
        </v-flex>
        <v-flex xs12>
          <v-progress-linear
            v-model="progressComprov"
            color="light-blue"
            height="15"
          >
            <!-- <strong>{{ progressComprov }} %</strong> -->
          </v-progress-linear>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="dialog = false"> Fechar </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </v-dialog>
</template>
<script>
import { eventBus } from "../../main";
import { firestorageBank } from "@/firebase/firestorageBank";
import firebase from "firebase";
import { saveBankBatch } from "../../services/BankBatchs";

export default {
  data() {
    return {
      dialog: false,
      fileNameComprov: null,
      progressComprov: 0,
      currentFile: null,
      id: null,
      color: "",
      snackMessage: "",
      snackbar: false,
    };
  },
  created() {
    var vm = this;
    eventBus.$on("uploadReceipt", function ({ show, id }) {
      vm.dialog = show;
      vm.id = id;
    });
  },
  methods: {
    onPickFileComprov() {
      this.$refs.comprovFile.click();
    },
    detectFiles(e, type) {
      let fileList = e.target.files || e.dataTransfer.files;
      console.log("e: ", e);
      console.log("type: ", type);

      Array.from(Array(fileList.length).keys()).map((x) => {
        if (type === "retorno") {
          this.uploadFile(fileList[x]);
          this.currentFile = fileList[x];
        } else if (type === "comprov") {
          this.uploadComprovFile(fileList[x]);
          this.currentFile = fileList[x];
        }
      });
    },
    async uploadComprovFile(file) {
      try {
        console.log("start uploading file: ", file);
        if (file && file.name) {
          this.processing = true;

          const filePath = `receipts/${file.name}`;
          const metadata = { contentType: file.type };

          var uploadTask = firestorageBank
            .ref()
            .child(filePath)
            .put(file, metadata);

          // Listen for state changes, errors, and completion of the upload.
          uploadTask.on(
            "state_changed", //firestorageBank.TaskEvent.STATE_CHANGED, // or 'state_changed'
            (snapshot) => {
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              this.progressComprov = Math.round(progress);
              console.log("Upload is " + this.progressComprov + "% done!");
              switch (snapshot.state) {
                case firebase.storage.TaskEvent.PAUSED: // or 'paused'
                  console.log("Upload is paused");
                  break;
                case firebase.storage.TaskEvent.RUNNING: // or 'running'
                  console.log("Upload is running");
                  break;
              }
            },
            (error) => {
              // A full list of error codes is available at
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case "storage/unauthorized":
                  // User doesn't have permission to access the object
                  this.snack(
                    "Não há autorização para o upload do arquivo.",
                    "red",
                  );
                  break;
                case "storage/canceled":
                  // User canceled the upload
                  this.snack("Upload cancelado.", "red");
                  break;

                // ...

                case "storage/unknown":
                  this.snack(
                    "Ocorreu um erro inesperado, tente novamente.",
                    "red",
                  );
                  // Unknown error occurred, inspect error.serverResponse
                  break;
              }
            },
            () => {
              // Upload completed successfully, now we can get the download URL
              uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                console.log("File available at", downloadURL);

                // Salva URL do Comprovante no BillinBatch
                saveBankBatch(this.id, downloadURL)
                  .then(() => {
                    this.snack(
                      "Upload de Comprovante de pagamento realizado com sucesso!",
                      "green",
                    );
                    this.progressComprov = 0;
                    this.dialog = false;
                  })
                  .catch((err) => {
                    this.snack(
                      "Erro ao realizar o Upload do Comprovante de pagamento! " +
                        err.message,
                      "red",
                    );
                  });
              });
            },
          );
          console.log("filePath: ", filePath);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.processing = false;
      }
    },
    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
  },
};
</script>
